export const types = {
  USER_SIGNUP: 'user/signup',
  USER_LOGIN: 'user/login',
  USER_AUTH_GOOGLE: 'user/authGoogle',
  USER_UPDATE: 'user/update',
  GET_PROFILE: 'user/getProfile',
  GET_VIEWABLE_PROFILE: 'user/getViewableProfile',
  USER_LOGOUT: 'user/logout',
  REPORT_SAVE: 'report/save',
  REPORT_DELETE: 'report/delete',
  REPORT_GET_IMAGES_UNSPLASH: 'report/getImagesUnsplash',
  GET_ALL_REPORTS: 'report/getAll',
  GET_USER_REPORTS: 'report/getUserReports',
  GET_REPORT_BY_ID: 'report/getReportById',
  GET_CURRENT_REPORT_BY_ID: 'report/getCurrentReportById',
  SUBMIT_FOR_REVIEW: 'report/submitForReview',
  APPROVE_REPORT: 'report/approve',
  REQUEST_CHANGES: 'report/requestChanges',
  PUBLISH_REPORT_FINAL: 'report/publishFinal',
  ADD_REVIEW_COMMENT: 'report/addComment',
  ADD_REVIEW_REPLY: 'report/addCommentReply',
  GET_NOTIFICATIONS: 'notification/getAll',
  GET_UNREAD_COUNT: 'notification/getUnreadCount',
  MARK_NOTIFICATION_READ: 'notification/markRead',
  MARK_ALL_READ: 'notification/markAllRead',
  GET_ALL_ORG_MEMBERS: 'orgMembers/getAll',
  CHANGE_USER_ROLE: 'orgMembers/changeRole',
};
